import { render } from "./TvmStartUpButtons.vue?vue&type=template&id=6c204b4c&scoped=true"
import script from "./TvmStartUpButtons.js?vue&type=script&lang=js&external"
export * from "./TvmStartUpButtons.js?vue&type=script&lang=js&external"

import "./TvmStartUpButtons.vue?vue&type=style&index=0&id=6c204b4c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c204b4c"],['__file',"src/Components/ChatWidget/TvmStartUpButtons/TvmStartUpButtons.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6c204b4c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6c204b4c', __exports__)) {
    api.reload('6c204b4c', __exports__)
  }
  
  module.hot.accept("./TvmStartUpButtons.vue?vue&type=template&id=6c204b4c&scoped=true", () => {
    api.rerender('6c204b4c', render)
  })

}


export default __exports__